<script setup lang="ts">
import {PaymentMethod} from "@/shared/graphql/types";
import {RadioCard, RadioCardGroup} from "@/shared/components/ui/radio-group";
import InlineSVG from "@/shared/components/InlineSVG.vue";
import {paymentMethodLabel} from "@/shared/composable/utils.ts";

interface Props {
  paymentMethods: PaymentMethod[]
  selected?: string
}

const props = defineProps<Props>()
const emit = defineEmits<{ (e: 'paymentMethod:selected', paymentMethod: PaymentMethod): void }>()

const selectPaymentMethod = (paymentMethodCode: string) => {
  emit('paymentMethod:selected', props.paymentMethods.find((paymentMethod) => paymentMethod.code === paymentMethodCode));
}
</script>

<template>
  <RadioCardGroup :default-value="selected" :col-span="2" :cols="2" @update:model-value="selectPaymentMethod">
    <RadioCard v-for="paymentMethod in paymentMethods" :value="paymentMethod.code">
      <div class="flex flex-col items-center justify-center h-full min-h-20">
        <InlineSVG v-if="paymentMethod.svg" :input="paymentMethod.svg"/>
        <p v-if="paymentMethodLabel(paymentMethod)">{{ paymentMethodLabel(paymentMethod) }}</p>
      </div>
    </RadioCard>
  </RadioCardGroup>
</template>

<style scoped>

</style>

